import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '../stores/auth';
import { SkeletonLoader } from './SkeletonLoader';

export function ProtectedRoute({ children }: { children: JSX.Element }): JSX.Element {
  const { user, loading, bootstrap } = useAuth();
  const [hasChecked, setHasChecked] = useState(false);

  useEffect(() => {
    if (!hasChecked && !user) {
      void bootstrap().finally(() => setHasChecked(true));
    } else if (user || hasChecked) {
      setHasChecked(true);
    }
  }, [user, bootstrap, hasChecked]);

  // Show skeleton loader until we've checked authentication at least once
  if (loading || !hasChecked) {
    return <SkeletonLoader />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
